import *as mobx from "mobx";
import EventEmitter from 'wolfy87-eventemitter';
import BaseStateProxy from "../../stateProxy/BaseStateProxy";
import context from "../../context";
import ClusterLayer from "../../layerManager/ClusterLayer";
import WmsLayer from "../../layerManager/WmsLayer";
import GeoJsonLayer from "../../layerManager/GeoJsonLayer";
import GridLayer from "../../layerManager/GridLayer";
import UTFGridLayer from "../../layerManager/UTFGridLayer";
import L from 'leaflet';
export default class LayerTreeStateProxy extends BaseStateProxy {
    _map = context.map;
    init() {
        BaseStateProxy.prototype.init.call(this);
        mobx.extendObservable(this.state, {
            baseMapKey: "OSM",
            existLayers: [],
            allLayers: context.appConfig.layer,
            clusterLayers:[],
        });
        // this.listeners.push(
        //     mobx.reaction(() => this.state.baseMapKey, baseMapKey => {
        //         this.emit(this.BASE_MAP_KEY, baseMapKey)
        //     })
        // );
    }
    setBaseMapKey(value) {
        this.state.baseMapKey = value;
    }

    getBaseMapKey() {
        return mobx.toJS(this.state.baseMapKey);
    }

    setExistLayers(value) {
        this.state.existLayers = value;
    }

    getExistLayers() {
        return mobx.toJS(this.state.existLayers);
    }

    setAllLayers(value) {
        this.state.allLayers = value;
    }

    getAllLayers() {
        return mobx.toJS(this.state.allLayers);
    }

    setClusterLayer(value) {
        this.state.clusterLayer = value;
    }

    getClusterLayers() {
        return mobx.toJS(this.state.clusterLayers);
    }

    getItemByrecurse(layersList=[],keyValue){
        let rtnItem = null;
        layersList&&layersList.some(item=>{
            if(item.children){
                rtnItem = this.getItemByrecurse(item.children,keyValue);
            }else{
                if(item.key===keyValue){
                    rtnItem = item;
                    return true
                }
            }
        });
        return rtnItem;
    }

    operateItems(items) {
        // console.log(items);
        const existLayers = this.getExistLayers();
        const allLayers = this.getAllLayers();
        if (items && items.length > 0) {
            items.map(m => {
                const layerCfg = existLayers.find(f => (f.key === m));
                let cfg = this.getItemByrecurse(allLayers,m);
                if (!layerCfg&&cfg) {
                    this.addLayer(cfg);
                }else{
                    this.updataLayer(layerCfg);
                }
            })
        } else {
            const layerCfg = existLayers.find(f => (f.key === items.key));
            if (!layerCfg) {
                this.removeLayer(layerCfg);
            }
        }
        this.setExistLayers(items);
    }
    updataLayer(item) {
    }
    removeLayer(item) {
        // context.map.removeLayer();
        let layers = this.getClusterLayers();
        let layer = layers.find(f=>f.layerId === item.layerId);
        layer.removeLayer();
        let flayer = layers.filter(f=>f.layerId !== item.layerId);
        this.setClusterLayers(flayer);
    }
    addLayer(item) {
        // console.log(item);
        let layer = null;
        switch(item.layerType){
            case "wfs":
                layer = new WmsLayer({
                    url:context.appConfig.mapserverUrl,
                    layerId:item.layerId
                });
                break;
            case "WMTS":
                break;
            case "WMS":
                layer = new WmsLayer({
                    layerId:item.key,
                    url: item.url,
                });
                break;
            default:
                break;
        }
        context.map.addLayer(layer);
        let layers = this.getClusterLayers();
        layers.push(layer);
        this.setClusterLayer(layers);
    }

}
LayerTreeStateProxy.prototype.BASE_MAP_KEY = "baseMapKey"